import { render, staticRenderFns } from "./root-vroms.vue?vue&type=template&id=5e88769b&"
import script from "./root-vroms.vue?vue&type=script&lang=ts&"
export * from "./root-vroms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports